module.exports = __webpack_public_path__ + "static/media/icon-form.06011ce3.svg";